import { Box, FormControl, Select } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const ITEM_HEIGHT = 40
const ITEM_PADDING_TOP = 8

export const LibrarySelect = styled(Select)<{ isselected?: string; noborder?: string; iscustom?: string }>`
  min-width: 113px;
  height: 40px;
  background: transparent;
  gap: ${theme.spacing.xSmall}px;
  border-radius: ${theme.attributes.borderRadius.small};
  border: 1px solid ${theme.colors.controlBorder};
  position: relative;

  ${({ noborder }) =>
    noborder &&
    noborder === 'true' &&
    `
    border-radius: 0;
    border: 0;
    border-color: transparent;
    background: transparent;
  `};

  color: ${theme.colors.foreground};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: left;

  ${({ isselected }) =>
    isselected &&
    isselected === 'true' &&
    `
    background: rgba(234, 221, 255, 0.08);
    border-color: ${theme.colors.cta};

    .MuiOutlinedInput-root {
      .MuiSelect-select {
        color: ${theme.colors.cta} !important;
      }
    }
  `};

  > * {
    border: none !important;
    outline: none !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none !important;
  }

  ${({ iscustom }) =>
    iscustom &&
    iscustom === 'true' &&
    `
      min-width: 122px;
      height: 40px;
  `};

  .MuiOutlinedInput-root {
    ${({ iscustom }) =>
      iscustom &&
      iscustom === 'true' &&
      `
      height: 40px;
  `};
  }

  svg.svg-dropdown {
    top: calc(50% - 0.6em);
    right: 13px;

    &.MuiSelect-icon {
      pointer-events: none;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
    }

    &.MuiSelect-iconClosed {
      transform: rotate(0deg) !important;
    }

    &.MuiSelect-iconOpen {
      transform: rotate(180deg) !important;
    }

    path {
      fill: ${theme.colors.legacyTextPrimary} !important;
    }
  }
`

/* Styling props use lowercase string values, such as noborder and iscustom below. These styled
 * wrappers put unknown props on the root DOM node of the MUI component. React reports a camelCase
 * attribute, and a boolean value on a custom attribute. */
export const Wrapper = styled(Box)<{ issort?: string }>`
  display: flex;
  align-items: center;

  ${({ issort }) =>
    issort !== 'true' &&
    `
      gap: ${theme.spacing.xSmall}px;
  `};

  .label-text {
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.xLarge};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: normal;
    color: ${theme.colors.foreground};
    white-space: nowrap;
    flex-shrink: 0;
  }
`

export const LibraryFormControl = styled(FormControl)<{
  noborder?: string
  isselected?: string
  iscustom?: string
  issort?: string
  minwidth?: string
}>`
  outline: none;
  min-width: 121px !important;
  height: 40px;
  border-radius: ${theme.attributes.borderRadius.small};
  display: flex;
  position: relative;
  max-width: ${({ issort }) => (issort === 'true' ? 'auto' : '121px')};

  @media (min-width: 1170px) {
    max-width: 200px !important;
  }

  ${({ noborder }) =>
    noborder !== 'true' &&
    `
      border: 1px solid ${theme.colors.controlBorder};
  `};

  ${({ isselected }) =>
    isselected &&
    isselected === 'true' &&
    `
      border-color: ${theme.colors.cta};
  `};

  ${({ minwidth }) =>
    minwidth &&
    `
      min-width: ${minwidth};
  `};

  .label-text {
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    color: ${theme.colors.foreground};
  }

  .MuiOutlinedInput-root {
    background: transparent;
    border: 0;
    color: ${theme.colors.foreground};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    gap: 2px;

    .MuiOutlinedInput-input {
      &.Mui-disabled {
        -webkit-text-fill-color: rgba(255, 255, 255, 0.3);
      }
    }
  }

  &:hover {
    background: rgba(234, 221, 255, 0.08);

    .MuiOutlinedInput-root {
      color: ${theme.colors.cta};
    }
  }

  svg {
    top: calc(50% - 0.6em);
    right: ${theme.spacing.small}px;

    path {
      fill: ${theme.colors.legacyTextPrimary};
    }
  }

  .MuiSelect-outlined {
    width: auto;
  }

  fieldset {
    padding: 0;
  }
`

export const CategoryMenuProps = {
  PaperProps: {
    sx: {
      background: theme.colors.legacyBackgroundDark,
      boxShadow: theme.attributes.boxShadow.selectFieldPaper,
      borderRadius: theme.attributes.borderRadius.small,
      minWidth: '321px !important',
      maxHeight: '372px !important',
      overflowY: 'hidden',

      '.MuiList-root': {
        padding: `${theme.spacing.xSmall}px !important`,

        '.all-option-form-control': {
          paddingLeft: '9px',

          '.MuiCheckbox-root': {
            'svg rect': {
              stroke: theme.colors.checkboxUnchecked
            },

            '&.Mui-checked svg path': {
              stroke: theme.colors.checkboxChecked
            }
          }
        },

        '.divider': {
          background: theme.colors.strokePrimary,
          width: '100%',
          height: '1px',
          margin: `${theme.spacing.half}px 0 ${theme.spacing.md}px`
        },

        '.list-wrapper': {
          maxHeight: '190px',
          height: '100%',
          overflowY: 'auto',

          '&::-webkit-scrollbar': {
            width: '4px',
            background: 'transparent'
          },

          '&::-webkit-scrollbar-track': {
            boxShadow: 'none',
            background: 'transparent'
          },

          '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.colors.legacyTextPrimary2,
            borderRadius: theme.attributes.borderRadius.secondary,
            "html[data-theme='light'] &": {
              backgroundColor: theme.colors.dropdownBorder
            }
          }
        }
      },

      '.MuiMenuItem-root': {
        height: '40px',
        padding: '0 !important',
        borderRadius: theme.attributes.borderRadius.small,
        maxWidth: 'calc(100% - 8px) !important',
        width: '100%',
        display: 'flex',
        alignItems: 'center',

        img: {
          marginRight: `${theme.spacing.xSmall}px`
        },

        '&:hover': {
          background: `${theme.colors.legacyPrimaryLight3} !important`,
          "html[data-theme='light'] &": {
            background: `${theme.colors.menuItemHover} !important`
          }
        },

        '&.Mui-selected, &.Mui-focusVisible': {
          "html[data-theme='light'] &": {
            background: `${theme.colors.cardFillTertiary} !important`
          }
        },

        '.MuiCheckbox-root': {
          padding: `${theme.spacing.xSmall}px`,

          'svg rect': {
            stroke: theme.colors.checkboxUnchecked
          },

          '&.Mui-checked svg path': {
            stroke: theme.colors.checkboxChecked
          },

          '&:hover': {
            background: 'rgba(202, 196, 208, 0.12)'
          }
        },

        '.MuiListItemText-root .MuiTypography-root': {
          fontFamily: theme.typography.fontFamily.primary,
          fontWeight: theme.typography.fontWeight.normal,
          fontSize: theme.typography.fontSize.xLarge,
          lineHeight: '24px',
          color: theme.colors.legacyNeutral2,
          paddingLeft: `${theme.spacing.xSmall}px`,
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        },

        '.sources-count-text': {
          color: theme.colors.legacyWhite4,
          fontSize: theme.typography.fontSize.xLarge,
          fontStyle: 'normal',
          fontWeight: theme.typography.fontWeight.normal,
          lineHeight: 'normal',
          marginLeft: `${theme.spacing.xSmall}px`
        },

        '.image-wrapper': {
          display: 'flex',

          '> img': {
            width: '18px',
            height: '18px',
            boxShadow: theme.attributes.boxShadow.chipCircle,
            margin: '-4.5px',
            borderRadius: theme.attributes.borderRadius.circle,

            '&:nth-of-type(1)': {
              zIndex: 10
            },
            '&:nth-of-type(2)': {
              zIndex: 9
            },
            '&:nth-of-type(3)': {
              zIndex: 8
            },
            '&:nth-of-type(4)': {
              zIndex: 7
            },
            '&:nth-of-type(5)': {
              zIndex: 6
            },
            '&:nth-of-type(6)': {
              zIndex: 5
            },
            '&:nth-of-type(7)': {
              zIndex: 4
            }
          }
        },

        '.textWrapper': {
          marginLeft: '13px'
        }
      },

      '&::-webkit-scrollbar': {
        width: '4px',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-track': {
        boxShadow: 'none',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.colors.legacyTextPrimary2,
        borderRadius: theme.attributes.borderRadius.secondary,
        "html[data-theme='light'] &": {
          backgroundColor: theme.colors.dropdownBorder
        }
      }
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
